import { useState } from 'react'

import { logger } from 'src/lib/logger'
import StartJourneyPopupBase from 'src/shared/components/ui/popups/start-journey/start-journey-popup-base'
import { useToast } from 'src/shared/hooks/use-toast'
import { formatToE164 } from 'src/shared/schemas/forms/consumer-auth'
import { useEventStore } from 'src/shared/store/event-store'

import { useConsumerStartJourney } from '../../consumers/api/use-consumer-start-journey'
import { useConsumerStartJourneyEvent } from '../../consumers/hooks/message-form/use-consumer-start-journey-event'
import type { StartJourneyButtonTrackingEvent } from '../schemas/start-journey-interfaces'

interface StartJourneyPopupProps {
  isOpen: boolean
  setOpen: (open: boolean) => void
  trackingEvent?: StartJourneyButtonTrackingEvent
  createdByUserId?: number
}

export default function StartJourneyPopup({ isOpen, setOpen, trackingEvent, createdByUserId }: StartJourneyPopupProps) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showSuccessView, setShowSuccessView] = useState(false)
  const { mutateAsync: consumerStartJourney } = useConsumerStartJourney()
  const sendEvent = useConsumerStartJourneyEvent()
  const { toast } = useToast()
  const { flowId } = useEventStore()
  const { gclid, fbclid } = useEventStore()

  const onSubmitPhoneNumberHandler = async (phoneNumber: string) => {
    const formattedPhoneNumber = formatToE164(phoneNumber)
    await onSubmitPhoneNumber(formattedPhoneNumber)
  }

  const onSubmitPhoneNumber = async (phoneNumber: string) => {
    try {
      setIsSubmitting(true)
      await consumerStartJourney({
        firstName: '',
        lastName: '',
        phoneNumber,
        gclid,
        fbclid,
        pageSource: trackingEvent?.pageName,
        createdByUserId,
      })
      if (trackingEvent) {
        sendEvent({ pageName: trackingEvent.pageName, action: 'phone_number_submit', flowId, tag: trackingEvent.tag })
      }
      setShowSuccessView(true)
    } catch (error) {
      logger.error('Error starting consumer journey:', error)
      toast({
        title: 'An unexpected error occurred',
        description: 'Please try again later.',
        variant: 'destructive',
      })
      if (trackingEvent) {
        sendEvent({
          pageName: trackingEvent.pageName,
          action: 'phone_number_submit_error',
          flowId,
          error: error instanceof Error ? error.message : 'Unknown error',
          tag: trackingEvent.tag,
        })
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <StartJourneyPopupBase
      isOpen={isOpen}
      setOpen={setOpen}
      onSubmit={onSubmitPhoneNumberHandler}
      showSuccessView={showSuccessView}
      isSubmitting={isSubmitting}
    />
  )
}
